<template>
  <div class="sign-up-page-container">
    <section
      v-if="!isSignUpSuccessful"
      class="sign-up-page card"
    >
      <h1 class="sign-up-page__headline">{{ $t('myPage.auth.signupTitle') }}</h1>
      <SignUp @sign-up-success="handleSignUpSuccess" />
    </section>
    <section
      v-else
      class="sign-up-page sign-up-page__confirmation card"
    >
      <h1 class="sign-up-page__headline">{{ $t('myPage.auth.signup.success') }}</h1>
      <p>
        {{ $t('myPage.auth.signup.sucessMessage') }}
      </p>
      <!-- <div class="sign-up-page__submit">
        <router-link
          :to="nextRoute"
          class="button button--medium button--primary sign-up-page__button"
        >
          {{ $t('myPage.auth.title') }}
        </router-link>
      </div> -->
    </section>
  </div>
</template>

<script lang="ts">
  import { defineComponent, ref, computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useI18n } from 'vue-i18n'
  import SignUp from '@/components/MyPage/SignUp/SignUp.vue'

  export default defineComponent({
    name: 'SignUpPage',
    components: {
      SignUp,
    },
    setup() {
      const { t } = useI18n()
      const isSignUpSuccessful = ref(false)
      const route = useRoute()

      const handleSignUpSuccess = () => {
        isSignUpSuccessful.value = true
      }

      const nextRoute = computed(() => {
        if (route.path === '/reiseplanlegger/opprett-profil') {
          return '/reiseplanlegger/personalia'
        } else if (route.path === '/min-side/sign-up') {
          return '/min-side/log-in'
        }
        return '/min-side/log-in'
      })

      return {
        isSignUpSuccessful,
        handleSignUpSuccess,
        nextRoute,
        t
      }
    },
  })
</script>

<style lang="scss" scoped>
  .sign-up-page-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    margin-left: 16px;
    padding: rem(16) 16px;
  }

  .sign-up-page {
    margin: rem(16) 16px;
    padding: rem(16) 16px;
    width: 100%;
    max-width: 543px;
    color: $clr-primary;
    background-color: $clr-white;
    box-shadow: $box-shadow-card;
    border-radius: 8px;

    @media screen and (min-width: $breakpoint-xs) {
      padding: rem(30) 30px;
    }

    &__headline {
      @include headline-medium;
      margin-top: 0;
      text-align: left;
    }

    p {
      text-align: left;
      margin: rem(30) 0;
      @include body-large;
    }

    &__submit {
      margin-bottom: 20px;
    }

    &__button {
      margin-top: rem(16);
      width: 100%;
    }
  }
</style>
